const ReadingGuide = () => {
  return (
    <svg
      width="96"
      height="92"
      viewBox="0 0 96 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="95.8548" height="92" rx="46" />
      <g clipPath="url(#clip0_150_3614)">
        <path
          d="M68.884 62.5651C68.884 66.3606 68.8406 69.706 68.884 73.0406C68.9274 75.3993 68.0056 76.4566 65.5114 76.4403C54.1322 76.3644 42.7457 76.3644 31.352 76.4403C28.8578 76.4403 27.9632 75.421 28.0336 73.0298C28.1312 69.6247 28.0336 66.2196 28.0336 62.5651C25.6316 62.5651 23.5766 62.6139 21.5271 62.5651C18.1654 62.4675 16.0616 60.5155 16.0182 57.1755C15.9314 50.2207 15.9314 43.2659 16.0182 36.3111C16.067 32.9006 18.0786 31.0571 21.5108 30.9812C23.5712 30.9324 25.6316 30.9812 28.0499 30.9812C28.0499 27.0772 28.0499 23.3902 28.0499 19.7248C28.0499 16.6342 28.5921 16.0594 31.6773 16.0594C42.874 16.0594 54.0707 16.0865 65.2945 16.0215C67.8538 16.0215 68.9165 17.0734 68.8677 19.5784C68.8081 23.2655 68.8677 26.9525 68.8677 30.9649C71.248 30.9649 73.3898 30.9161 75.5261 30.9649C78.8824 31.0625 80.7097 32.8572 80.7368 36.2298C80.791 43.181 80.791 50.1339 80.7368 57.0887C80.7097 60.5426 78.8065 62.4404 75.3797 62.5434C73.341 62.6247 71.2751 62.5651 68.884 62.5651ZM76.5509 35.2592H43.5192C36.5681 35.2592 29.6151 35.2592 22.6603 35.2592C21.4512 35.2592 20.3179 35.1562 20.3396 36.9943C20.4047 43.5009 20.3396 50.0074 20.4155 56.514C20.4155 57.0887 21.1367 58.1406 21.5867 58.1406C23.6905 58.3196 25.816 58.222 28.0933 58.222C28.0933 56.3676 28.1909 54.9253 28.0933 53.5047C27.8927 51.081 28.8741 50.0454 31.3466 50.0616C42.8089 50.1122 54.2749 50.1122 65.7446 50.0616C68.0707 50.0616 69.025 51.1081 68.9274 53.3637C68.8569 54.9416 68.9274 56.5248 68.9274 58.2436C70.957 58.3218 72.9893 58.2965 75.0164 58.1677C75.379 58.0557 75.7073 57.8537 75.9708 57.5807C76.2344 57.3077 76.4246 56.9724 76.5238 56.6062C76.5943 49.6712 76.5509 42.7309 76.5509 35.2592ZM64.389 71.8423V54.5783H32.3605V71.8423H64.389ZM32.3659 30.8402H64.4378V20.7225H32.3659V30.8402Z"
          fill="black"
        />
        <path
          d="M48.6763 61.9032C45.7103 61.9032 42.7119 62.0605 39.7839 61.811C38.8134 61.7297 37.9296 60.5911 37.0078 59.935C37.9187 59.1596 38.808 57.7661 39.7189 57.7228C45.5585 57.5167 51.409 57.5276 57.2486 57.7228C58.1433 57.7499 59 59.0566 59.8784 59.7723C59.0108 60.4826 58.1975 61.7189 57.2757 61.8056C54.4454 62.0822 51.5554 61.8978 48.6763 61.9032Z"
          fill="black"
        />
        <path
          d="M48.4458 46.1845C45.4799 46.1845 42.4814 46.3417 39.5535 46.0923C38.5829 46.011 37.6991 44.8723 36.7773 44.2162C37.6883 43.4409 38.5775 42.0474 39.4884 42.004C45.328 41.798 51.1785 41.8088 57.0182 42.004C57.9128 42.0311 58.7695 43.3379 59.6479 44.0536C58.7804 44.7639 57.967 46.0001 57.0453 46.0869C54.2149 46.3634 51.3249 46.1791 48.4458 46.1845Z"
          fill="black"
        />
        <path
          d="M48.6732 64.4945H57.0775C58.574 64.4945 60.0814 64.9446 59.7886 66.6634C59.6476 67.4875 58.124 68.637 57.1968 68.6695C51.4222 68.8539 45.6422 68.8702 39.8731 68.6695C38.8971 68.637 37.9699 67.2761 37.0156 66.5278C38.0187 65.8609 38.9784 64.7114 40.0358 64.6138C42.8824 64.321 45.7886 64.4999 48.6732 64.4945Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_150_3614">
          <rect
            width="64.7891"
            height="60.4405"
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReadingGuide;
